import React from 'react';

type Importer = () => Promise<{ default: React.ComponentType }>;

export function lazyElement(importer: Importer): JSX.Element {
  const Component = React.lazy(importer);
  return <Component />;
}
